

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit, FaTrash } from 'react-icons/fa';
import config from "../../../config/config";
import { getAuthToken } from "../../../utils/token";
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../loader/Loader';
import Select from "react-select";
const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#0d6efd',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  },
};

export default function Bom() {
  const [dataList, setDataList] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [listLoading, setListLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [productList, setProductList] = useState([]);
  const [materialList, setMaterialList] = useState([])
  const initialState = {
    product_id: '',
    material_id: '',
    quantity: '',
    min_quantity: '',
    max_quantity: '',
    required_quantity: '',
    unit: '',
    status: '',
    vendor: '',
    cost: '',
    remarks: '',
    approved_at: ''
  };
  const [form, setForm] = useState(initialState);
  useEffect(() => {
    fetchList();
    fetchMaterialList()
    fetchProductList()
  }, []);
  const fetchList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/bom/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataList(res.data.boms || []);
    } catch (err) {
      console.error("Error fetching BOM list:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };
  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProductList(res.data.products || []);
    } catch (err) {
      console.error("Error fetchProductList:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };
  const fetchMaterialList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/material/master/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMaterialList(res.data.materials || []);
    } catch (err) {
      console.error("fetchMaterialList:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };
  const [units, setUnits] = useState([]);
  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await axios.post(`${config.API}/getUnit`, {}, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });
      setUnits(res.data);
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: null }));
  };
  const openAddModal = () => {
    setForm(initialState);
    setErrors({});
    setIsEditing(false);
    setEditingId(null);
    setShowModal(true);
  };
  const openEditModal = (item) => {
    setForm({
      ...item,
      approved_at: item.approved_at ? item.approved_at.replace(' ', 'T') : ''
    });
    setErrors({});
    setIsEditing(true);
    setEditingId(item.id);
    setShowModal(true);
  };
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication missing");
      return;
    }
    setErrors({});
    const payload = {
      product_id: Number(form.product_id),
      material_id: Number(form.material_id),
      quantity: Number(form.quantity),
      min_quantity: Number(form.min_quantity),
      max_quantity: Number(form.max_quantity),
      required_quantity: Number(form.required_quantity),
      unit: form.unit,
      status: form.status,
      vendor: form.vendor,
      cost: Number(form.cost),
      remarks: form.remarks,
      approved_at: form.approved_at ? form.approved_at.replace('T', ' ') : null
    };

    setFormLoading(true);
    try {
      if (isEditing && editingId) {
        await axios.put(`${config.API}/bom/${editingId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success("Updated successfully");
      } else {
        let response = await axios.post(`${config.API}/bom/create`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(response.data.message);
      }
      setShowModal(false);
      fetchList();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        console.error("Submit error:", err);
        toast.error("Submit failed! Please try again.");
      }
    } finally {
      setFormLoading(false);
    }
  };
  const filtered = dataList.filter(item =>
    Object.values(item).join(' ').toLowerCase().includes(filterText.toLowerCase())
  );
  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Product', selector: row => row.product?.name, sortable: true },
    { name: 'Material', selector: row => row.material?.material_name, sortable: true },
    { name: 'Quantity', selector: row => row.quantity, sortable: true },
    { name: 'Min Qty', selector: row => row.min_quantity, sortable: true },
    { name: 'Max Qty', selector: row => row.max_quantity, sortable: true },
    { name: 'Required Qty', selector: row => row.required_quantity, sortable: true },
    { name: 'Unit', selector: row => row.unit, sortable: true },
    { name: 'Status', selector: row => row.status, sortable: true },
    { name: 'Vendor', selector: row => row.vendor, sortable: true },
    { name: 'Cost', selector: row => row.cost, sortable: true },
    { name: 'Remarks', selector: row => row.remarks, sortable: true },
    { name: 'Approved At', selector: row => row.approved_at ? new Date(row.approved_at).toLocaleString() : '', sortable: true },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-primary" onClick={() => openEditModal(row)}><FaEdit /></button>
          <button className="btn btn-sm btn-danger"><FaTrash /></button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong className="mb-0 fs-4">BOM Details</strong>
        <div>
          <input
            type="text"
            className="form-control d-inline-block me-2"
            placeholder="Search..."
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            style={{ width: '200px' }}
          />
          <button className="btn btn-primary" onClick={openAddModal}>+ Add Bom</button>
        </div>
      </div>

      {listLoading ? (
        <div className="text-center"><Loader /></div>
      ) : (
        <DataTable
          columns={columns}
          data={filtered}
          pagination
          highlightOnHover
          customStyles={customStyles}
        />
      )}

      {showModal && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary text-light">
                <h5>{isEditing ? 'Edit BOM' : 'Add BOM'}</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)} />
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Product</label>
                    <Select
                      name="product_id"
                      value={
                        productList
                          .map((p) => ({ value: p.id, label: p.name }))
                          .find((option) => option.value === form.product_id) || null
                      }
                      onChange={(selectedOption) =>
                        setForm((prev) => ({
                          ...prev,
                          product_id: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={productList.map((p) => ({
                        value: p.id,
                        label: p.name,
                      }))}
                      isDisabled={formLoading || listLoading}
                      placeholder="-- Select Product --"
                      isSearchable
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.product_id ? "red" : base.borderColor,
                        }),
                      }}
                    />
                    {errors.product_id && (
                      <div className="text-danger small mt-1">{errors.product_id[0]}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Material</label>
                    <Select
                      name="material_id"
                      value={
                        materialList
                          .map((m) => ({ value: m.id, label: m.material_name }))
                          .find((option) => option.value === form.material_id) || null
                      }
                      onChange={(selectedOption) =>
                        setForm((prev) => ({ ...prev, material_id: selectedOption ? selectedOption.value : "" }))
                      }
                      options={materialList.map((m) => ({
                        value: m.id,
                        label: m.material_name,
                      }))}
                      isDisabled={formLoading || listLoading}
                      placeholder="-- Select Material --"
                      isSearchable
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.material_id ? "red" : base.borderColor,
                        }),
                      }}
                    />
                    {errors.material_id && (
                      <div className="text-danger small mt-1">{errors.material_id[0]}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Quantity</label>
                    <input type="text" name="quantity" className="form-control"
                      value={form.quantity} onChange={handleInput} disabled={formLoading} />
                    {errors.quantity && (
                      <div className="text-danger small">{errors.quantity[0]}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Min Quantity</label>
                    <input type="text" name="min_quantity" className="form-control"
                      value={form.min_quantity} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Max Quantity</label>
                    <input type="text" name="max_quantity" className="form-control"
                      value={form.max_quantity} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Required Quantity</label>
                    <input type="text" name="required_quantity" className="form-control"
                      value={form.required_quantity} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Unit</label>

                    <select
                      name="unit"
                      className="form-select"
                      value={form.unit}
                      onChange={handleInput}
                      disabled={formLoading}
                    >
                      <option value="">Select Unit</option>

                      {units.map((unit) => (
                        <option key={unit.id} value={unit.name}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <input type="text" name="status" className="form-control"
                      value={form.status} onChange={handleInput} disabled={formLoading} />
                    {errors.status && (
                      <div className="text-danger small">{errors.status[0]}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Vendor</label>
                    <input type="text" name="vendor" className="form-control"
                      value={form.vendor} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Cost</label>
                    <input type="text" name="cost" className="form-control"
                      value={form.cost} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-8">
                    <label className="form-label">Remarks</label>
                    <input type="text" name="remarks" className="form-control"
                      value={form.remarks} onChange={handleInput} disabled={formLoading} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Approved At</label>
                    <input type="datetime-local" name="approved_at" className="form-control"
                      value={form.approved_at} onChange={handleInput} disabled={formLoading} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)} disabled={formLoading}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={formLoading}>
                  {formLoading ? 'Saving...' : isEditing ? 'Update' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}




